import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { AgencyPopup } from './components/AgencyPopup';
function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-black selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Services data-id="element-3" />
      <Process data-id="element-4" />
      <FAQ data-id="element-5" />
      <Contact data-id="element-6" />

      <footer className="py-12 text-center text-neutral-400 text-sm bg-white border-t border-neutral-100" data-id="element-7">
        <p className="uppercase tracking-widest" data-id="element-8">
          © {new Date().getFullYear()} Адвокатські послуги. Всі права захищені.
        </p>
      </footer>

      <AgencyPopup data-id="element-9" />
    </div>;
}
export { App };